import { createSlice } from "@reduxjs/toolkit";
import { fetchHome } from "../actions/homeAction";
// import { ILoginInitialState } from "../states/loginState";
import { REHYDRATE } from "redux-persist";

const initialState = {
  data: {
    id: 0,
    mini_title_ID: 0,
    mini_title: [],
    title: "",
    sub_title: "",
    content: "",
    image: "",
    video: "",
    button: "",
    active: true,
    created_user_id: 0,
    created_user_name: "",
    created_date: "",
    updated_user_id: 0,
    updated_user_name: "",
    updated_date: "",
  },
  isLoading: false,
  error: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    home: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHome.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHome.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchHome.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(REHYDRATE, (state) => {
      const { data } = state;
      state.isLoading = false;
      state.data = data;
    });
  },
});

export const { home } = homeSlice.actions;

export default homeSlice.reducer;
